// extracted by mini-css-extract-plugin
export default {"root":"root--WURrU","copy":"copy--SDNlW","countdown":"countdown--ZAM2r","warning":"warning--hpe43","promo":"promo--zJ_Fl","cta":"cta--W_lw_"};